/**
 * 从meta中解析组件属性
 * @param {*} meta 
 */
export function getPropsFromMeta(props,meta){
    const {schema:{properties}} = meta;
    const metaProp =  Object.keys(properties) || [];
    let config = {};
    for(let prop of metaProp){
        config[prop] = props[prop];
    }
    return config;
}